import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarDay, Timesheetexception } from 'toolbandi-ui-lib';

@Component({
	selector: 'app-timesheet-edit-modal',
	templateUrl: './timesheet-edit-modal.component.html',
	styleUrls: ['./timesheet-edit-modal.component.scss']
})
export class TimesheetEditModalComponent implements OnInit {

	calendarDay: CalendarDay;
	title: string;

	constructor(
		private activeModal: NgbActiveModal
	) { }

	ngOnInit() {
		if (!this.calendarDay.exception) {
			this.calendarDay.exception = new Timesheetexception();
			this.calendarDay.exception.hours = this.calendarDay.workingHours;
		}
	}

	submit() {
		this.activeModal.close(this.calendarDay.exception);
	}

	dismiss() {
		this.activeModal.dismiss();
	}

}
